const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/validators/action-validators.js